export default "__VITE_ASSET__CC$T8WYw__"